module.exports = __webpack_public_path__ + "img/Pailles_pour_mariage.51a482a.jpg";